export const getCoverPhotoIndex = publicData => {
  const parsedIndex = Number.parseInt(publicData?.coverPhotoIndex, 10);
  return Number.isFinite(parsedIndex) && parsedIndex >= 0 ? parsedIndex : 0;
};

export const getCoverPhoto = (images, publicData) => {
  const imageList = Array.isArray(images) ? images : [];
  if (imageList.length === 0) {
    return null;
  }

  const coverPhotoIndex = getCoverPhotoIndex(publicData);
  return imageList[coverPhotoIndex] || imageList[0];
};

export const orderImagesByCoverPhoto = (images, publicData) => {
  const imageList = Array.isArray(images) ? images.filter(Boolean) : [];
  if (imageList.length < 2) {
    return imageList;
  }

  const coverPhotoIndex = getCoverPhotoIndex(publicData);
  if (coverPhotoIndex <= 0 || coverPhotoIndex >= imageList.length) {
    return imageList;
  }

  const coverPhoto = imageList[coverPhotoIndex];
  return [
    coverPhoto,
    ...imageList.slice(0, coverPhotoIndex),
    ...imageList.slice(coverPhotoIndex + 1),
  ];
};

export const getCloudinaryCoverPhoto = publicData =>
  getCoverPhoto(publicData?.cloudnaryImage, publicData);

// Cloudinary delivery URLs are NOT signature-locked (unlike the Sharetribe
// imgix hosted assets, whose `s=` signature forbids re-transforming), so we can
// right-size and modernise them on the fly. We insert a transformation right
// after `/upload/`:
//   f_auto     -> serve WebP/AVIF where the browser supports it
//   q_auto     -> let Cloudinary pick an efficient quality level
//   c_limit,w_ -> cap the delivered width (no upscaling) to a sensible card size
//                 (1024 protects retina desktop cards while shrinking full-res
//                 originals, which can be several thousand px wide)
// This directly reduces oversized/original-format listing images flagged by
// Lighthouse's "Improve image delivery" audit. Every caller of this helper
// renders a card/thumbnail (listing cards, search/map cards, favorites, manage
// listings) — no full-size detail view uses it — so the width cap is safe.
const CLOUDINARY_TRANSFORM = 'f_auto,q_auto,c_limit,w_1024';

export const getCloudinaryImageUrl = image => {
  const url = image?.secure_url || image?.url || '';
  // Only transform standard Cloudinary delivery URLs; leave anything else as-is.
  if (!url || !url.includes('/upload/')) {
    return url;
  }
  // Don't double-insert if we've already applied our transformation.
  if (url.includes(`/upload/${CLOUDINARY_TRANSFORM}`)) {
    return url;
  }
  return url.replace('/upload/', `/upload/${CLOUDINARY_TRANSFORM}/`);
};
